<script>
// import comp from '@/components/comp';

export default {
	name: 'Message',
	props: ['message', 'timeout'],
	components: {},
	data () {
		return {
			defaultTimeout: 3500
		};
	},
	watch: {
		message () {
			window.setTimeout( () => this.$emit('update:message',false), this.ourTimeout);
		},
	},
	computed: {
		ourTimeout () {
			return ( typeof this.timeout == 'undefined' )
				? this.defaultTimeout
				: this.timeout;
		}
	}
}
</script>

<template>
	<transition name="fade-down">
		<div class="modal-message-wrap" v-if="message">
			<div class="modal-message">
				{{ message }}
			</div>
		</div>
	</transition>
</template>


<style scoped lang="scss">
// applied throughout enter transition
// applied throughout leave transition
.fade-down-enter-active ,
.fade-down-leave-active {
	transition: all .3s;
}
// start the transition in
.fade-down-enter {
	opacity: 0;
	transform: translateY(-20px);
}
// end the transition out
.fade-down-leave-to {
	opacity: 0;
	transform: translateY(50px);
}
// end the transition in, start the transition out
.fade-down-enter-to, .fade-down-leave {
	opacity: 1;
	transform: translateY(0);
}

.modal-message-wrap {
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	top: 0;
	left: 0;
	height: 100vh;
	width: 100vw;
	z-index: 101;
	// background: hsla(0, 0%, 100%, .7);
}
.modal-message {
	display: inline-block;
	padding: 2em;
	background: hsl(63, 96%, 58%);
	color: black;
	border: 2px solid hsl(63, 100%, 30%);
	border-radius: 2px;
	box-shadow: 2px 2px 2px hsla(0, 0%, 0%, .3);
	position: relative;
	top: -15vh;

	&.success {

	}
}
</style>